import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Company,
  CompanyService,
  TranslationService,
  User,
  UserService
} from '@lciapps/lci-core';
import { Subscription } from 'rxjs';
import { FeatureService } from 'src/app/feature.service';
import { ServiceTypeEnum } from 'src/app/features/activities/shared/models/service-type.enum';
import { ApplicationInsightsService } from '../../application-insights.service';
import { MetricsService } from '../../features/activities/metrics.service';
import { ActivityDetail } from '../../features/activities/shared/models/activity-detail.model';
import { Activity } from '../../features/activities/shared/models/activity-post.model';
import { ActivityStatus } from '../../features/activities/shared/models/activity-status.enum';
import { ActivitiesService } from '../../features/activities/shared/services/activities.service';
import { ReportingService } from '../../features/activities/shared/services/reporting.service';
import { ActivitiesDisclaimerComponent } from '../activities-disclaimer/activities-disclaimer.component';
import { CapsDialogComponent } from '../caps-dialog.component';
import { SpinnerService } from '../spinner/spinner.service';
declare var analyticsDataLayer;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  public regexMatch = "<\s*###[^>]*>(.*?)<\s*/\s*###>";
  public anchorDelimiter = "<###>";
  public closeAnchorDelimiter = "</###>";
  private user: User = new User();
  public displayActivities: Array<Activity[]> = [];
  public signatureActivites: Array<Activity[]> = [];
  public company: Company = new Company();
  public summary: any = new ActivityDetail();
  public activitiesLoaded = false;
  private subscriptions: Array<Subscription> = [];
  public clubs = [];
  public showClubSelector: boolean;
  private lblSignatureActivities: string;
  public currentLionYear: number;
  public thisYear: number;
  public lblCurrentLionYear = 'Current Lion Year';
  public capDisclaimer: string =
    "Some metrics are capped. Please <###>click here</###> to see which metrics are impacted.";
  public formattedCapDisclaimer: string;
  @ViewChild('capHtmlElement') public capHtmlElement: ElementRef;
  public activitiesDisclaimer: string =
    "Reported activities may not immediately be reflected in the metrics. <###>Details</###>";
  public formattedActivitiesDisclaimer: string;
  @ViewChild('activitiesDisclaimerElement') public activitiesDisclaimerElement: ElementRef;

  constructor(
    private userService: UserService,
    private companyService: CompanyService,
    private reportingService: ReportingService,
    private activitiesService: ActivitiesService,
    private translationService: TranslationService,
    private featureService: FeatureService,
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService,
    private insightsService: ApplicationInsightsService,
    private metricsService: MetricsService,
    private dialog: MatDialog
  ) {
    /**/
  }

  /**
   * Angular hook, loads the current user and company
   */
  public ngOnInit(): void {
    this.featureService.activateMenuLink(0);

    this.translationService
      .getTranslationValue('lblNewMetricsDisclaimer')
      .subscribe((value) => {
        this.capDisclaimer = value;
        this.getCapDisclaimer();
      });
    this.getCapDisclaimer();

    this.translationService
      .getTranslationValue('lblNewReportedActivitiesDisclaimer')
      .subscribe((value) => {
        this.activitiesDisclaimer = value;
        this.getactivitiesDisclaimer();
      });
    this.getactivitiesDisclaimer();
    // analyticsDataLayer.push({
    //   event: 'Pageview',
    //   url: location.pathname,
    //   title: 'ServiceActivityHome'
    // });

    this.translationService
      .getTranslationValue('lblSignatureActivities')
      .subscribe((val) => {
        this.lblSignatureActivities = val;
      });
    this.translationService
      .getTranslationValue('lblCurrentLionYear')
      .subscribe((res) => {
        this.lblCurrentLionYear = res;
      });
    this.insightsService.logPageView('Home');
    this.subscriptions.push(
      this.userService.userLoaded.subscribe((user) => {
        this.user = user;
        this.thisYear = new Date().getFullYear();
        const currentDate = new Date();
        this.currentLionYear = currentDate.getFullYear();
        if (new Date().getMonth() + 1 < 7) {
          this.currentLionYear -= 1;
        }
        const clubMembershipClaim = user.claims.find(
          (c) => c.claimType === 'MyLion'
        );
        if (clubMembershipClaim) {
          const companyIds = clubMembershipClaim.claimValue.split(',');
          this.featureService.getCompanies(companyIds).subscribe((s) => {
            this.clubs = s;
            this.company = s[0];
            this.loadSummary();
          });
        }
        this.activitiesService
          .getUserActivitiesSummary(this.user.id, '', '')
          .subscribe((res) => {
            this.setDisplayActivities(
              res.filter((item) => {
                return (
                  item.activityStatus !== ActivityStatus.Deleted &&
                  item.endDate > this.featureService.getFormattedDate(new Date())
                );
              })
            );
            this.activitiesLoaded = true;
          });
      })
    );
    this.subscriptions.push(
      this.companyService.company.subscribe((company) => {
        this.company = company;
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  private getCapDisclaimer() {
    const linkFromTranslatedCapValue = (this.capDisclaimer.match(this.regexMatch))[1];

    if (linkFromTranslatedCapValue.length > 0) {
      const aTagForCapValue = `<a target="_blank">${linkFromTranslatedCapValue}</a>`;
      this.formattedCapDisclaimer = this.capDisclaimer.replace(
        this.anchorDelimiter + linkFromTranslatedCapValue + this.closeAnchorDelimiter,
        aTagForCapValue
      );
    }
  }

  private getactivitiesDisclaimer() {
    const linkFromTranslatedCapValue = (this.activitiesDisclaimer.match(this.regexMatch))[1];
    if (linkFromTranslatedCapValue.length > 0) {
      const aTagForCapValue = `<a target="_blank">${linkFromTranslatedCapValue}</a>`;
      this.formattedActivitiesDisclaimer = this.activitiesDisclaimer.replace(
        this.anchorDelimiter + linkFromTranslatedCapValue + this.closeAnchorDelimiter,
        aTagForCapValue
      );
    }
  }

  public companySelected(company) {
    this.spinnerService.enableSpinner.next(true);
    this.company = company;
    this.showClubSelector = false;
    this.loadSummary();
  }

  /**
   * Navigate to the explore screen
   */
  public navToExplore(): void {
    this.router.navigate(['/activities/explore', this.company.companyId], {
      relativeTo: this.route,
    });
  }

  /**
   * Load header summary details
   */
  private loadSummary(): void {
    let currentYear = new Date().getFullYear();
    if (new Date().getMonth() + 1 < 7) {
      currentYear -= 1;
    }
    const startDate = +`${currentYear}0701`;
    const endDate = +`${currentYear + 1}0630`;

    if (this.company && this.company.baseCompanyType == 'Multiple District') {
      this.metricsService
        .getMultipleDistrictActivitySummary(
          this.company.companyId,
          startDate,
          endDate,
          1,
          1000,
          null
        )
        .subscribe((res) => {
          this.summary = res;
          this.spinnerService.enableSpinner.next(false);
        });
    } else if (this.company && this.company.baseCompanyType === 'District') {
      this.metricsService
        .getDistrictActivitySummary(
          this.company.companyId,
          startDate,
          endDate,
          1,
          1000,
          null
        )
        .subscribe((res) => {
          this.summary = res;
          this.spinnerService.enableSpinner.next(false);
        });
    } else {
      this.reportingService
        .getClubActivitySummary(
          this.company.companyId || this.user.userProfile.companyId,
          startDate,
          endDate
        )
        .subscribe((res) => {
          this.summary = res;
          this.spinnerService.enableSpinner.next(false);
        });
    }
  }

  createActivity(): void {
    this.router.navigate([
      '/activities/create',
      { type: ServiceTypeEnum.Future },
      'new',
    ]);
  }

  /**
   * Navigates to one of the menu areas
   * @param {string} where
   */
  public navigateTo(where: string): void {
    switch (where) {
      case 'learn':
        this.translationService
          .getTranslationValue('lnkServiceJourneyLearn')
          .subscribe((url) => {
            window.open(url, '_blank');
          });
        break;
      case 'discover':
        this.router.navigate(['/activities/discover'], {
          relativeTo: this.route,
        });
        break;
      case 'create':
        this.router.navigate([
          '/activities/create',
          { type: ServiceTypeEnum.Future },
          'new',
        ]);
        break;
      case 'explore':
        this.router.navigate(['/activities/explore'], {
          relativeTo: this.route,
        });
        break;
    }
  }

  /**
   * Navigate to specified activity on preview screen
   * @param {number} activityId
   */
  public navigateToActivity(activity: Activity): void {
    const activityId = activity.activityId;
    const activitySource = activity.activitySource;
    if (activitySource === 'UserNew') {
      this.router.navigate(
        ['/activities/create/review-activity', { activityId }],
        { relativeTo: this.route }
      );
    } else {
      this.router.navigate(['/activities/discover/preview', { activityId }], {
        relativeTo: this.route,
      });
    }
    // this.router.navigate(['/activities/discover/preview', { activityId }], {
    //   relativeTo: this.route
    // });
  }

  /**
   * Sets display list of activities
   */
  private setDisplayActivities(activities: Activity[]): void {
    activities.sort((firstActivity, nextActivity) =>
      (firstActivity.endDate > nextActivity.endDate ? 1 : -1)); // sort by newest to oldest
    this.signatureActivites = this.groupActivities(
      activities.filter((activity) => activity.signatureFlag === true).slice(0, 5)
    );
    this.displayActivities = this.groupActivities(activities.slice(0, 5));
  }

  private groupActivities(activities: Activity[]) {
    const groups: Array<Array<Activity>> = [];
    let groupIdx = 0;
    let group = [];
    activities.forEach((activity) => {
      if (groupIdx === 5) {
        groups.push(group);
        groupIdx = 0;
        group = [];
      }
      group.push(activity);
      groupIdx++;
    });
    if (groupIdx > 0) {
      groups.push(group);
    }
    return groups;
  }

  openCapsDialog() {
    this.dialog.open(CapsDialogComponent, {
      width: '350px',
      data: alert[0],
    });
  }
  openDisclaimerDialog() {
    this.dialog.open(ActivitiesDisclaimerComponent, {
      width: '380px',
    });
  }
}
